<template>
  <div class="yk-qw-content">
    <div style="width:100%;">
      知识点：
      <el-select style="width:20%"
                 v-model="knowledgeId"
                 slot="prepend"
                 @change="getQuestionListByPage(1)"
                 placeholder="请选择">
        <el-option label="全部"
                   value=""></el-option>
        <el-option v-for="(item,index) in knowledgeLists"
                   :key="index"
                   :label="item.KnowledgeName"
                   :value="item.Id"></el-option>
      </el-select>
      题型：
      <el-select style="width:20%"
                 v-model="queTypevalue"
                 slot="prepend"
                 @change="getQuestionListByPage(1)"
                 placeholder="请选择">
        <el-option label="单选题"
                   value="1"></el-option>
        <el-option label="多选题"
                   value="2"></el-option>
        <el-option label="判断题"
                   value="3"></el-option>
        <el-option label="填空题"
                   value="4"></el-option>
        <el-option label="简答题"
                   value="5"
                   v-if="!IsTest"></el-option>
        <el-option label="综合题"
                   value="6"
                   v-if="!IsTest"></el-option>
      </el-select>
      难度：
      <el-select style="width:20%"
                 v-model="diffTypeValue"
                 slot="prepend"
                 @change="getQuestionListByPage(1)"
                 placeholder="请选择">
        <el-option label="简单"
                   value="1"></el-option>
        <el-option label="一般"
                   value="2"></el-option>
        <el-option label="困难"
                   value="3"></el-option>
      </el-select>
    </div>
    <el-container>
      <el-main>
        <el-table ref="multipleTable"
                  :data="questionLists"
                  tooltip-effect="dark"
                  style="width: 100%"
                  @selection-change="handleSelectionChangeDialog"
                  :row-key="getRowKeys">
          <el-table-column type="selection"
                           :reserve-selection="true"
                           :selectable="checkboxInit">
          </el-table-column>
          <el-table-column label="序号"
                           width="60"
                           type="index"></el-table-column>
          <el-table-column label="知识点"
                           width="250">
            <template slot-scope="scope">
              <span v-if="scope.row.KnowledgeName">{{scope.row.KnowledgeName}}</span>
              <span v-else>未设置知识点</span>
            </template>
          </el-table-column>
          <el-table-column label="题干">
            <template slot-scope="scope">
              <span v-html="scope.row.content"></span>
            </template>
          </el-table-column>
          <el-table-column label="题目类型"
                           prop="questionType"
                           width="150">
          </el-table-column>
          <el-table-column label="题目难度"
                           prop="difficulty"
                           width="150"
                           show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="onPageChangeHandler"
                       :current-page="pageIndex"
                       :page-sizes="[10,50,100,200,500,1000]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"
                       style="margin-top:20px;"
                       v-show="total>0">
        </el-pagination>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  name: 'questionList',
  props: {
    courseId: {
      type: String,
      default: ''
    },
    courseOpenId:{
      type: String,
      default: ''
    },
    exitIds: {
      type: Array,
      default: ''
    },
    IsTest: {
      type: Boolean,
      default: false
    },
    isclear: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      queTypevalue: '',
      diffTypeValue: '',
      active: '',
      // 被选中的值
      checkedIds: [],
      // 接口数据
      total: 0,
      pageSize: 6,
      pageIndex: 1,
      knowledgeLists: [],
      questionLists: [],
      type: ['', '单选题', '多选题', '判断题', '填空题', '简答题', '综合题'],
      difficult: ['', '简单', '一般', '困难'],
      knowledgeId: '',
      knowledgeName: '',
      page: 1,
      totalCount: 0,
      notsetCount: 0,
      checkedbtn: true,
      checkbtn: false,
      // 获取row的key值
      getRowKeys(row) {
        return row.questionId;
      },
      // 选中的行
      checkRow: []
    };
  },
  watch: {
    checkRow: function(val) {
      this.checkedIds = [];
      var checkTotalScore = 0;
      val.forEach(element => {
        this.checkedIds.push(element.questionId);
        if(element.questionType=="综合题"){
          checkTotalScore += 0;
        }else{
          checkTotalScore += 0;
        }
      });
      this.$emit('update:checkedIds', this.checkedIds);
      this.$emit('update:checkTotalScore', checkTotalScore);
    },
    isclear: function() {
      if (this.isclear === 1) {
        this.clearMembers();
      }
    }
  },
  created() {
    console.log(this.courseId);
    this.getKnowledgeList();
  },
  methods: {
    /// 清除弹窗中的选中值
    clearMembers() {
      this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
    },
    // 获取知识点数据
    getKnowledgeList: function() {
      debugger;
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/getQuestionKnowledge",{
        courseId: this.courseId,
        courseOpenId : this.courseOpenId,
      }).then(function(rst) {
        if (rst && rst.code > 0) {
          that.knowledgeLists = rst.knowledgeList;
          that.page = 1;
          that.getQuestionList();
        }
      });
    },
    /* 获取题库数据 */
    getQuestionList: function() {
      this.checkedbtn = true;
      this.checkbtn = false;
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/getQuestionList",{
        courseId:this.courseId,
        courseOpenId:this.courseOpenId,
        IsTest:this.IsTest,
        knowledgeId:this.knowledgeId,
        queTypevalue:this.queTypevalue,
        diffTypeValue:this.diffTypeValue,
        page:this.page,
        PageSize:this.pageSize
      }).then(function(rst) {
        that.total = rst.pagination.totalCount;
        that.pageSize = rst.pagination.pageSize;
        that.pageIndex = rst.pagination.pageIndex;
        that.questionLists = rst.list;
        that.questionLists.forEach(element => {
          (element.questionType = that.type[element.questionType]),
          (element.difficulty = that.difficult[element.difficulty]);
        });
      });
    },
    /* 获取题库数据 */
    getQuestionListByPage: function(page) {
      this.checkedbtn = true;
      this.checkbtn = false;
      this.$http.post("/api/design/Paper/getQuestionList",{
        courseId : this.courseId,
        IsTest : this.IsTest,
        knowledgeId: this.knowledgeId,
        queTypevalue: this.queTypevalue,
        diffTypeValue: this.diffTypeValue,
        page:this.page,
        pageSize: this.pageSize,
      }).then(rst => {
        this.total = rst.pagination.totalCount;
        this.pageSize = rst.pagination.pageSize;
        this.pageIndex = rst.pagination.pageIndex;
        this.questionLists = rst.list;
        this.questionLists.forEach(element => {
          (element.questionType = this.type[element.questionType]),
          (element.difficulty = this.difficult[element.difficulty]);
        });
      });
      this.clearMembers();
    },
    /* 分页 */
    onPageChangeHandler(page) {
      this.page = page;
      this.getQuestionList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getQuestionList();
    },
    /* 设置选中行 */
    handleSelectionChangeDialog(val) {
      this.checkRow = val;
    },
    /* 默认是否已选中 */
    checkboxInit(row, index) {
      let IsExit = this.exitIds.indexOf(row.questionId) >= 0;
      if (IsExit) { return 0; } // 不可勾选
      else return 1; // 可勾选
    },
    checkAll() {
      this.checkbtn = true;
      this.checkedbtn = !this.checkbtn;
    },
    RemoveAllcheck() {
      this.checkedbtn = true;
      this.checkbtn = !this.checkedbtn;
    }
  }
};
</script>

<style lang="scss">
.yk-qw-content {
  .el-container {
    .el-aside {
      .yk-el-aside {
        .yk-qu-con {
          display: flex;
          justify-content: space-between;
          padding: 13px 15px;
          border-bottom: 1px solid #f5f5f5;
          vertical-align: center;
          cursor: pointer;
          span,
          .yk-title {
            display: inline-block;
          }
          .yk-title {
            padding: 0 5px;
            text-align: center;
            min-width: 140px;
          }
          &:hover {
            background-color: #409eff;
          }
        }
        .active {
          background-color: #409eff;
          color: black;
        }
        .yk-add-group {
          margin-top: 20px;
          margin-bottom: 10px;
          text-align: center;
          cursor: pointer;
          font-size: 17px;
          color: #009688;
          i {
            font-weight: bolder;
            color: #409eff;
          }
        }
      }
    }
    .el-main {
      .yk-main-head {
        .yk-que-name {
          display: flex;
          float: left;
          .el-dropdown {
            .el-dropdown-link {
              font-size: 20px;
            }
          }
          .test-name {
            margin-right: 10px;
          }
          i:hover {
            cursor: pointer;
          }
          i {
            margin-left: 10px;
          }
        }
        .yk-que-config {
          float: right;
        }
        &:after {
          display: block;
          height: 0px;
          content: '';
          clear: both;
        }
      }
      .yk-main-que-content {
        padding-bottom: 5px;
        // border-bottom: 2px solid #f5f5f5;
        .yk-que-con:first-child {
          margin-top: 0px;
        }
        .yk-que-con {
          margin-top: 20px;
          padding-bottom: 20px;
          border-bottom: 1px solid #d7d7d7;
          .yk-que-head {
            .yk-que-head-info {
              float: left;
              .que-type,
              .diff-type {
                margin-left: 10px;
              }
            }
            .yk-que-head-operate {
              float: right;
              .el-icon-more {
                margin: 0 20px;
                font-size: 17px;
                transform: rotate(90deg);
                -ms-transform: rotate(90deg);
                -moz-transform: rotate(90deg);
                -webkit-transform: rotate(90deg);
                -o-transform: rotate(90deg);
              }
            }
            &:after {
              display: block;
              height: 0;
              content: '';
              clear: both;
            }
          }
          .yk-que-opotion {
            margin-top: 10px;
            ul {
              list-style: none;
              li {
                margin-top: 10px;
                span:first-child {
                  margin-right: 10px;
                  font-weight: bolder;
                }
              }
            }
          }
        }
      }
      .el-pagination {
        text-align: center;
      }
      .el-table__row:nth-child(even) {
        background-color: #ffffff;
      }
      .el-table__row:nth-child(odd) {
        background-color: #fafafa;
      }
      .el-table {
        margin-top: 20px;
        thead {
          tr th {
            background-color: #e9eff5;
          }
        }
      }
    }
    .yk-dialogCon {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1000;
      background-color: rgba(0, 0, 0, 0.4);
      .yk-choiceCon {
        padding: 0 0 20px;
        position: absolute;
        overflow: auto;
        left: 50%;
        top: 50px;
        margin-left: -370px;
        width: 740px;
        height: 500px;
        background-color: white;
        .yk-add-group {
          position: fixed;
          padding: 5px 0;
          width: 740px;
          left: 50%;
          margin-left: -370px;
          z-index: 1000;
          background-color: #409eff;
          span {
            margin: 0 20px;
            color: white;
            font-size: 16px;
          }
          .el-icon-close {
            position: absolute;
            top: 10px;
            right: 10px;
            color: white;
            font-size: 25px;
            font-weight: bolder;
            cursor: pointer;
          }
        }
      }

      &.slide-enter-active,
      &.slide-leave-active {
        transition: all 0.4s;
        background-color: rgba(0, 0, 0, 0);
      }
      .yk-choice-main {
        margin-top: 60px;
      }
    }
    .yk-que-detail {
      .yk-que-choice {
        ul {
          list-style: none;
          li {
            span:first-child {
              font-weight: bolder;
            }
            span:last-child {
              margin-left: 10px;
              color: gray;
            }
          }
        }
      }
      .yk-que-type {
        padding: 10px 0;
        span:last-child {
          margin-left: 10px;
        }
      }
      .yk-que-head {
        font-weight: bolder;
      }
    }
    .el-checkbox__inner {
      border: 2px solid #409eff;
    }
  }
}
</style>
